<mat-card class="card shadow m-3" *ngFor="let znamka of data; let ix = index;">
  <mat-card-content class="p-1 p-md-3">

      <!-- Desktop -->

    <div class="row d-none d-md-flex align-items-center justify-content-center">
      <div class="col-5 pointer text-start ps-5" (click)="openPredmetDetail(znamka)">
        <div><b>{{znamka.predmetNazov}}</b></div>
        <div class="text-nowrap grey">{{znamka.predmetSkratka}} <span *ngIf="znamka.jazyk">({{znamka.jazyk}})</span></div>
        @if (znamka.nahradzam) {
          <div class="grey fst-italic ms-3">→ {{znamka.nahradzam}}</div>
        }
      </div>

      <div class="col-2 text-center grey">
        <div class="text-nowrap pointer" (click)="openDetailAtributovPredmetu(znamka)"
            [matTooltip]="'Detail atribútov predmetu' | translate" [matTooltipPosition]="'above'">
            <div>
                <span class="badge text-bg-secondary"><b>{{znamka.kredit}}<span i18n>kreditSkratka</span></b></span>
                <span class="badge text-bg-secondary ms-1" *ngIf="znamka.kodSemester"><b>{{znamka.kodSemester}}S</b></span>
                <span class="badge text-bg-secondary ms-1" *ngIf="znamka.kodSposobUkoncenia"><b>{{znamka.kodSposobUkoncenia}}</b></span>
            </div>
        </div>

        <div class="mt-3" *ngIf="znamka.rozsah !== null" (click)="openRozvrhoveAkcie(znamka)" [matTooltip]="'Prihlásiť na rozvrh' | translate">
          <div *ngIf="znamka.prihlasovanieRozvrh && znamka.rozsah === znamka.rozvrh" class="text-nowrap myalert badge text-bg-success">
            {{znamka.rozsah}}
          </div>
          <div *ngIf="znamka.prihlasovanieRozvrh && znamka.rozvrh !== null && znamka.rozsah !== znamka.rozvrh" class="text-nowrap myalert badge text-bg-warning">
            {{znamka.rozsah}} ({{znamka.rozvrh}})
          </div>
          <div *ngIf="znamka.prihlasovanieRozvrh && znamka.rozvrh === null" class="text-nowrap myalert badge text-bg-danger">
            {{znamka.rozsah}}
          </div>
          <div *ngIf="!znamka.prihlasovanieRozvrh" class="text-nowrap myalert badge text-bg-secondary">
            {{znamka.rozsah}}
          </div>
        </div>

      </div>

      <div class="col-3 text-center pointer d-flex align-items-center justify-content-center">
        <div *ngIf="znamka.hodnotenieKod" (click)="openHodnotenieDetail(znamka)">
          <div class="text-wrap"><b>{{znamka.hodnotenieKod}}<span *ngIf="znamka.hodnoteniePopis"> - {{znamka.hodnoteniePopis}}</span></b></div>
          <div class="text-black-50" *ngIf="znamka.hodnotiaci">{{znamka.hodnotiaci}}</div>
        </div>
      </div>

      <div class="col-1 text-black-50">
        <button mat-icon-button (click)="delete(znamka)" [matTooltip]="'Odobrať zo zápisného listu' | translate">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>

      <div class="col-1 text-center grey">
        <div>
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Zobraziť ďalšie možnnosti" [matTooltip]="'Ďalšie možnosti' | translate">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openRozvrhoveAkcie(znamka)">
              <span i18n>Prihlásiť na rozvrh</span>
            </button>
            <button mat-menu-item (click)="onRozvrhOdhlasit(znamka)">
              <span i18n>Odhlásiť z rozvrhu</span>
            </button>
            <button mat-menu-item (click)="openHodnotenieDetail(znamka)">
              <span i18n>Detail hodnotenia</span>
            </button>
            <button mat-menu-item (click)="openPredmetDetail(znamka)">
              <span i18n>Detail predmetu</span>
            </button>
            <button mat-menu-item (click)="openPrerekvizity(znamka)">
              <span i18n>Kontrola prerekvizít</span>
            </button>

            @if (znamka.kodCastSP !== 'SS' && config?.zapis === true) {
              <button mat-menu-item (click)="openOpakovanyZapis(znamka)">
                <span i18n>Náhrada za predmet</span>
              </button>
            }

            @if (znamka.nahradzam !== null && config?.zapis === true) {
              <button mat-menu-item (click)="zrusNahradu(znamka)">
                <span i18n>Zrušenie náhrady</span>
              </button>
            }

            <button class="d-block d-sm-none" mat-menu-item (click)="delete(znamka)">
              <span i18n>Odobrať</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

      <!-- Mobile -->

    <div class="row d-block d-md-none">
      <div class="d-flex flex-row align-items-start w-100 p-0">
        <div class="flex-grow-1 p-2 pb-0 text-left">
            <div><b>{{znamka.predmetNazov}}</b></div>
            <div class="grey"> ({{znamka.predmetSkratka}})</div>
          @if (znamka.nahradzam) {
            <div class="grey fst-italic ms-3 mb-2">→ {{znamka.nahradzam}}</div>
          }
        </div>
        <div class="ms-auto grey">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Zobraziť ďalšie možnosti">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>

        <div>
            <div class="text-nowrap mb-2 mt-2 d-flex flex-row align-items-center justify-content-around">
                <div (click)="openDetailAtributovPredmetu(znamka)">
                    <div class="badge text-bg-secondary"><b>{{znamka.kredit}}<span i18n>kreditSkratka</span></b></div>
                    <div class="badge text-bg-secondary ms-1" *ngIf="znamka.kodSemester"><b>{{znamka.kodSemester}}S</b></div>
                    <div class="badge text-bg-secondary ms-1" *ngIf="znamka.kodSposobUkoncenia"><b>{{znamka.kodSposobUkoncenia}}</b></div>
                </div>

                <div *ngIf="znamka.rozsah !== null" (click)="openRozvrhoveAkcie(znamka)" [matTooltip]="'Prihlásiť na rozvrh' | translate">
              <span *ngIf="znamka.prihlasovanieRozvrh && znamka.rozsah === znamka.rozvrh" class="text-nowrap myalert badge text-bg-success">
                {{znamka.rozsah}}
              </span>
                    <span *ngIf="znamka.prihlasovanieRozvrh && znamka.rozvrh !== null && znamka.rozsah !== znamka.rozvrh" class="text-nowrap myalert badge text-bg-warning">
                {{znamka.rozsah}} ({{znamka.rozvrh}})
              </span>
                    <span *ngIf="znamka.prihlasovanieRozvrh && znamka.rozvrh === null" class="text-nowrap myalert badge text-bg-danger">
                {{znamka.rozsah}}
              </span>
                    <span *ngIf="!znamka.prihlasovanieRozvrh" class="text-nowrap myalert badge text-bg-secondary">
                {{znamka.rozsah}}
              </span>
                </div>
            </div>
        </div>

        <div *ngIf="znamka.hodnotenieKod">
          <hr/>
          <div class="d-flex flex-row justify-content-center p-2 pt-0">
            <div>
              <div><strong>{{znamka.hodnotenieKod}}<span *ngIf="znamka.hodnoteniePopis"> - {{znamka.hodnoteniePopis}}</span></strong></div>
              <div *ngIf="znamka.hodnotiaci">{{znamka.hodnotiaci}}</div>
            </div>
          </div>
        </div>

      </div>

  </mat-card-content>
</mat-card>


